import { render, staticRenderFns } from "./admin-dashboard.vue?vue&type=template&id=4053e118"
import script from "./admin-dashboard.vue?vue&type=script&lang=js"
export * from "./admin-dashboard.vue?vue&type=script&lang=js"
import style0 from "./admin-dashboard.vue?vue&type=style&index=0&id=4053e118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports